<template>
  <div :class="'itemHelperLine ' + orientation" :style="getPos">
    <div class="lineInfo">
      <span v-html="infoText"></span>
      {{ $t("cm") }}
    </div>
  </div>
</template>
<script>
import { useEditorFilesStore } from "@/stores/modules/editorFiles";
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { mapState, mapActions } from "pinia";

export default {
  props: ["item", "index", "orientation"],
  computed: {
    ...mapState(useImageEditorStore, ["getReady", "getEditor"]),
    unit: function () {
      var imageUnit = this.getEditor.dim.imageDimByFormat.unit;
      var canvasUnit = this.getEditor.dim.canvasDimByFormat.unit;
      return imageUnit / canvasUnit;
    },
    infoText: function () {
      if (this.getReady) {
        var itemLeft = parseFloat(this.item.left);
        var itemBottom = parseFloat(this.item.bottom);
        if (this.item.hasOwnProperty("deviation")) {
          itemLeft = itemLeft - parseFloat(this.item.deviation.x);
          itemBottom = itemBottom + parseFloat(this.item.deviation.y);
        }
        var left = itemLeft;
        var bottom = itemBottom;
        switch (this.orientation) {
          case "horizontal":
            return left.toFixed(2);
          case "vertical":
            return bottom.toFixed(2);
        }
      }
      return 0;
    },
    getPos: function () {
      if (this.getReady) {
        var itemLeft = this.item.left;
        var itemBottom = this.item.bottom;
        if (this.item.hasOwnProperty("deviation")) {
          itemLeft = itemLeft - this.item.deviation.x;
          itemBottom = itemBottom + this.item.deviation.y;
        }
        var left = itemLeft * this.unit;
        var bottom = itemBottom * this.unit;
        switch (this.orientation) {
          case "horizontal":
            return {
              width: Math.round(left) + "px",
              bottom: Math.round(bottom) + "px"
            };
          case "vertical":
            return {
              left: Math.round(left) + "px",
              height: Math.round(bottom) + "px"
            };
        }
      }
      return {};
    }
  },
  methods: {}
};
</script>
